/* Patchstore24 – eigener Produkt-Konfigurator (ersetzt Globo Product Options), DE-Version
 * Preise kommen live aus den Shopify-Preisprodukten (window.PS_CONFIG, per Liquid gerendert).
 * Rechnet sofort bei jeder Eingabe, ohne Netzwerk-Request. Maße in cm, Fläche in cm².
 */
(function () {
  'use strict';
  var C = window.PS_CONFIG;
  if (!C || !C.tiers || !C.tiers.length) return;

  /* ---------- Optionen pro Produkt ---------- */
  var SUB_BORDER = 'Wie der Rand Ihres Patches abgeschlossen wird';
  var SUB_ATT = 'Wie Ihr Patch an Kleidung oder Ausrüstung hält';
  var BORDER_EMB = { key: 'Umrandung', sub: SUB_BORDER, options: [
    { v: 'Gestickte Umrandung', d: 'Gestickter Rand, der dem Design folgt.' },
    { v: 'Gekettelte Umrandung', d: 'Dicker, umwickelter Rand – der Klassiker.' },
    { v: 'Lasercut', d: 'Feiner Schnitt entlang jeder Kontur.' }] };
  var BACKING_STD = { key: 'Befestigung', sub: SUB_ATT, options: [
    { v: 'Zum Aufnähen', d: 'Stoffrückseite zum Annähen. Am haltbarsten.' },
    { v: 'Zum Aufbügeln', d: 'Klebefolie – mit dem Bügeleisen aufbringen.' },
    { v: 'Selbstklebend', d: 'Abziehen und aufkleben.' },
    { v: 'Klett – Hakenseite', d: 'Hakenteil – haftet auf vorhandenem Flauschband.', addon: 'addon-gestickt-gedruckt-klett-einseitig' },
    { v: 'Klett – beidseitig', d: 'Haken- plus Flauschteil zum Annähen – überall nutzbar.', addon: 'addon-gestickt-gedruckt-klett-beidseitig' }] };
  var RUBBER_ATT = { key: 'Befestigung', sub: SUB_ATT, options: [
    { v: 'Ohne', d: 'Nur der Patch, ohne Befestigung.' },
    { v: 'Klett – Hakenseite', d: 'Klett auf der Rückseite – haftet auf jedem Flauschband.', addon: '3d-rubber-klett-einseitig' },
    { v: 'Klett – beidseitig', d: 'Klett am Patch plus Flauschteil zum Annähen.', addon: '3d-rubber-klett-beidseitig' },
    { v: 'Schlüsselring', d: 'Ring oben am Patch – für Schlüssel oder Reißverschluss.', addon: 'addon-rubber-schlusselring' },
    { v: 'Karabiner', d: 'Karabiner oben am Patch – für Taschen, Gürtel oder Ausrüstung.', addon: 'addon-rubber-karabiner' }] };
  var YARN = ['Schwarz','Weiß','Silber','Grau','Lila','Orange','Rot','Pink','Rosenrot','Kardinalrot','Braun','Dunkelbraun','Hellbraun','Kaffeebraun','Olivgrün','Neongrün','Grün','Dunkelgrün','Columbia-Blau','Himmelblau','Blau','Königsblau','Marineblau','Gelb','Vegas-Gold','New-Vegas-Gold','Gold','Altgold'];
  var FELT = ['Weiß','Schneeweiß','Schwarz','Hellgrau - R03','Grau - R04','Dunkelgrau - R05','Orange - R06','Rot - R07','Dunkelrot - R08','Weinrot - R09','Bordeaux - R10','Türkis - R11','Grün - R12','Dunkelgrün - R13','Braun - R15','Hellblau - R16','Himmelblau - R17','Blau - R18','Königsblau - R19','Marineblau - R20','Gelb - R21','Beige - R22','Gold - R23','Sonnengelb - R24','Kaffee - R25','Hellrosa - R26','Pink - R31','Pink - R27','Lila - R28','Violett - R29','Dunkellila - R30'];

  var PRODUCTS = {
    'gestickte-patches': { groups: [BORDER_EMB, BACKING_STD] },
    'gedruckte-patches': { groups: [
      { key: 'Umrandung', sub: SUB_BORDER, options: [
        { v: 'Gekettelte Umrandung', d: 'Klassischer, dicker Rand. Ideal für einfache Formen.' },
        { v: 'Lasercut', d: 'Feiner, sauberer Rand – folgt jeder Form.' }] },
      BACKING_STD] },
    'gewebte-patches': { groups: [
      { key: 'Umrandung', sub: SUB_BORDER, options: [
        { v: 'Gekettelte Umrandung', d: 'Dicker, umwickelter Rand.', addon: 'addon-gewebte-patches-gekettelte-umrandung' },
        { v: 'Lasercut', d: 'Feiner Schnitt entlang jeder Kontur.' }] },
      { key: 'Befestigung', sub: SUB_ATT, options: [
        { v: 'Zum Aufnähen', d: 'Stoffrückseite zum Annähen. Am haltbarsten.' },
        { v: 'Zum Aufbügeln', d: 'Klebefolie – mit dem Bügeleisen aufbringen.', addon: 'addon-gewebte-patches-selbstklebend-bugelfolie' },
        { v: 'Selbstklebend', d: 'Abziehen und aufkleben – ohne Werkzeug.', addon: 'addon-gewebte-patches-selbstklebend-bugelfolie' },
        { v: 'Klett – Hakenseite', d: 'Hakenteil – haftet auf vorhandenem Flauschband.', addon: 'addon-gewebte-patches-klett-einseitig' },
        { v: 'Klett – beidseitig', d: 'Haken- plus Flauschteil zum Annähen – überall nutzbar.', addon: 'addon-gewebte-patches-klett-zweiseitig' }] }] },
    'chenille-patches': { groups: [
      { key: 'Befestigung', sub: SUB_ATT, options: [
        { v: 'Ohne Befestigung', d: 'Filzrückseite ohne Kleber – fertig zum Annähen.' },
        { v: 'Zum Aufbügeln', d: 'Hitzeaktivierte Rückseite – mit dem Bügeleisen aufbringen.', addon: 'addon-chenille-patches-bugelfolie' },
        { v: 'Selbstklebend', d: 'Zum Aufkleben – für schnellen, temporären Halt.' },
        { v: 'Doppelte Filzunterlage', d: 'Zusätzliche Filzlage für ein dickeres, hochwertiges Finish.', addon: 'addon-chenille-patches-doppelte-filzunterlage' }] }],
      colors: { yarn: YARN, slots: 6, felt: FELT } },
    'pailletten-patches': { groups: [
      { key: 'Umrandung', sub: SUB_BORDER, options: [
        { v: 'Gekettelte Umrandung', d: 'Dicker, umwickelter Rand.' },
        { v: 'Lasercut', d: 'Feiner Schnitt entlang jeder Kontur.' }] },
      { key: 'Befestigung', sub: SUB_ATT, options: [
        { v: 'Zum Aufnähen', d: 'Glatte Rückseite – für dauerhaften Halt annähen.' },
        { v: 'Zum Aufbügeln', d: 'Hitzeaktivierte Rückseite – mit dem Bügeleisen aufbringen.' }] }] },
    '2d-rubber-patches': { groups: [RUBBER_ATT] },
    '3d-rubber-patches': { groups: [RUBBER_ATT] },
    'emaille-pin': { groups: [] },
    'gewebte-label': { groups: [
      { key: 'Falzung', sub: 'Wie das Label gefaltet und eingenäht wird', options: [
        { v: 'Ohne Falz (flach)', d: 'Flaches Label zum Aufnähen an allen vier Seiten.' },
        { v: 'Mittelfalz', d: 'In der Mitte gefaltet – klassisches Nackenlabel.' },
        { v: 'Seitenfalz', d: 'Beide Enden umgeschlagen – zum Einnähen in die Naht.' },
        { v: 'Buchfalz', d: 'Wie ein Buch gefaltet – Platz für Pflegehinweise.' }] }] },
    'schlusselanhanger': { groups: [] }
  };
  var P = PRODUCTS[C.handle];
  if (!P) return;

  /* Bilder pro Gruppe (Index) und Option (liegen in Shopify > Inhalte > Dateien als swatch-<id>.jpg) */
  var IMG = {
    'gestickte-patches': [['17867868118648','17867869087286','17867869459335'],['17867871902812','17867872075435','17867872280521','17867872572222','17867872783644']],
    'gedruckte-patches': [['17867937582055','17867938678546'],['17867929855929','17867929916901','17867930090920','17867930238015','17867930462910']],
    'gewebte-patches': [['17868449500880','17868449756947'],['17868413839919','17868413940100','17868413635179','17868414113839','17868423833589']],
    'chenille-patches': [['17868530808758','17868530297177','17868529296592','17868529491759']],
    'pailletten-patches': [['17869689073823','17869689225313'],['17869690919832','17869691468184']],
    '2d-rubber-patches': [['17868756589222','17868756954537','17868756791096','17868756284712','17868757143025']],
    '3d-rubber-patches': [['17868662611249','17868663107716','17868663263927','17868662013270','17868662370886']]
  };
  var YARN_IMG = ["1_1_1721076377252-1721077018","1_2_1721077054524-1721077477","1_3_1721077054525-1721077493","1_4_1721077054526-1721077509","1_5_1721077054527-1721077524","1_6_1721077465433-1721077597","1_7_1721077465434-1721077612","1_8_1721077465435-1721077638","1_9_1721077465436-1721077719","1_10_1721077465437-1721077786","1_11_1721077465438-1721077827","1_12_1721077465440-1721077837","1_13_1721077465441-1721077855","1_14_1721077465442-1721077871","1_15_1721077465443-1721077887","1_16_1721077465444-1721077896","1_17_1721077465445-1721077926","1_18_1721077465446-1721077937","1_19_1721077465447-1721077962","1_20_1721077465448-1721077973","1_21_1721077465449-1721077982","1_22_1721077465450-1721077992","1_23_1721077465451-1721078021","1_24_1721077465452-1721078029","1_25_1721077465453-1721078056","1_26_1721077465454-1721078067","1_27_1721077465455-1721078082","1_28_1721077465456-1721078117"];
  var FELT_IMG = ["7_1_1721123660745-1721123685","7_2_1721123660746-1721123711","7_3_1721123660747-1721123720","7_4_1721123660748-1721123733","7_5_1721123660750-1721123745","7_6_1721123660751-1721123755","7_7_1721123660752-1721123764","7_8_1721123660753-1721123815","7_9_1721123660754-1721123852","7_10_1721123660755-1721123865","7_11_1721123660756-1721123872","7_12_1721123660757-1721123883","7_13_1721123660758-1721123890","7_14_1721123660759-1721123900","7_15_1721123660760-1721123917","7_16_1721123660761-1721123929","7_17_1721123660762-1721123937","7_18_1721123660763-1721123949","7_19_1721123660764-1721123960","7_20_1721123660765-1721123971","7_21_1721123660766-1721124025","7_22_1721123660767-1721124034","7_23_1721123660768-1721124045","7_24_1721123660769-1721124110","7_25_1721123660770-1721124119","7_26_1721123660771-1721124129","7_31_1721123660776-1721124175","7_27_1721123660772-1721124137","7_28_1721123660773-1721124143","7_29_1721123660774-1721124153","7_30_1721123660775-1721124167"];
  function swatch(id) { return '/cdn/shop/files/swatch-' + id + '.jpg?width=240'; }
  function dropImg(id) { return '/cdn/shop/files/image-dropdown-' + id + '.jpg?width=96'; }


  /* ---------- Daten aufbereiten ---------- */
  function num(s) { return parseFloat(String(s).replace(',', '.')); }
  function de(n) { return String(Math.round(n * 100) / 100).replace('.', ','); }
  // Mindestmenge aus dem Variantentitel ("10-24", "2000" oder "… - 100-199")
  function minOf(t) { var m = /(\d+)(?:-\d+)?\s*$/.exec(String(t)); return m ? parseInt(m[1], 10) : 0; }
  function cleanVariants(list) {
    var clean = list.filter(function (v) { return /^\s*\d+(-\d+)?\s*$/.test(v.t); });
    if (clean.length) list = clean; // falsch benannte Alt-Varianten ignorieren
    var seen = {}, out = [];
    list.map(function (v) { return { id: v.id, title: v.t, price: v.p / 100, min: minOf(v.t) }; })
      .sort(function (a, b) { return a.min - b.min; })
      .forEach(function (v) { if (!seen[v.min]) { seen[v.min] = 1; out.push(v); } });
    return out;
  }
  var tiers = C.tiers.map(function (t) {
    var m = /(?:Area|Fläche)\s+([\d.,]+)\s*-\s*([\d.,]+)/i.exec(t.title || '');
    return { lo: m ? num(m[1]) : 0, hi: m ? num(m[2]) : 0, label: m ? (m[1] + '–' + m[2]) : '', handle: t.handle, variants: cleanVariants(t.variants) };
  }).filter(function (t) { return t.hi > 0 && t.variants.length; }).sort(function (a, b) { return a.lo - b.lo; });
  if (!tiers.length) return;
  var qtyMins = tiers[0].variants.map(function (v) { return v.min; });
  var MIN_QTY = qtyMins[0] || 1;
  var MAX_AREA = tiers[tiers.length - 1].hi;

  // Add-on-Preise aus der serverseitig gerenderten Addon-Liste (Collection "addon"), Zuordnung über die Stufe
  var addons = {};
  document.querySelectorAll('.addon-products-list .addon-product').forEach(function (el) {
    addons[el.dataset.addonHandle] = Array.prototype.map.call(el.querySelectorAll('.addon-variant'), function (v) {
      return { id: parseInt(v.dataset.variantId, 10), title: v.dataset.variantTitle, price: parseFloat(v.dataset.variantPrice) };
    });
  });
  function addonVariant(handle, tierIdx) {
    var list = addons[handle];
    if (!list || !list.length) return null;
    var label = tiers[tierIdx] && tiers[tierIdx].label.replace('–', '-');
    for (var i = 0; i < list.length; i++) if (list[i].title === label) return list[i];
    return list[tierIdx] || null;
  }

  /* ---------- DOM ---------- */
  var form = document.querySelector('product-form form[action*="/cart/add"]');
  if (!form) return;
  var wIn = document.getElementById('product_width');
  var hIn = document.getElementById('product_height');
  var qIn = document.querySelector('.quantity__input[form="' + form.id + '"]') || document.querySelector('.quantity__input');
  var submitBtn = form.querySelector('[type="submit"]');
  var buttons = form.querySelector('.product-form__buttons') || form;
  var fmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: C.currency || 'EUR' });

  if (qIn) { qIn.min = MIN_QTY; qIn.value = ''; qIn.placeholder = 'Andere'; }

  /* Anker: Beispielpreis vor jeder Eingabe (erste Größen-Empfehlung, 100 Stück) */
  var ANCHOR_Q = Math.max(100, MIN_QTY);
  var firstChip = document.querySelector('.ps-sz-b');
  var AW = firstChip ? num(firstChip.dataset.w) : 6, AH = firstChip ? num(firstChip.dataset.h) : 5;
  // Größen-Empfehlungen über der Maximalfläche ausblenden (z. B. beim Pin)
  document.querySelectorAll('.ps-sz-b').forEach(function (b) { if (num(b.dataset.w) * num(b.dataset.h) > MAX_AREA + 1e-9) b.style.display = 'none'; });

  /* Mengen-Buttons mit Stückpreis */
  var CHIP_Q = [10, 25, 50, 100, 200, 300, 500, 1000];
  var chipQs = qtyMins.filter(function (m) { return CHIP_Q.indexOf(m) > -1; });
  var qWrap = qIn && (qIn.closest('.product-form__quantity') || qIn.parentNode);
  var qChips = document.createElement('div');
  qChips.className = 'ps-qty';
  qChips.innerHTML = '<div class="ps-qty__g">' +
    chipQs.map(function (m) { return '<button type="button" class="ps-qty__b" data-q="' + m + '"><b>' + m + '</b><span class="ps-qty__p">&nbsp;</span></button>'; }).join('') + '</div>';
  if (qWrap && qWrap.parentNode) qWrap.parentNode.insertBefore(qChips, qWrap);
  qChips.addEventListener('click', function (e) { var b = e.target.closest('.ps-qty__b'); if (!b) return; qIn.value = b.dataset.q; touched = true; render(); });
  [wIn, hIn].forEach(function (el) { if (el) { el.removeAttribute('form'); el.setAttribute('inputmode', 'decimal'); el.step = '0.1'; } });

  /* Schritt-Köpfe (Ziffer + Headline in Caps) */
  var stepNo = 0;
  function head(title, sub) { stepNo++; return '<div class="ps-head"><span class="ps-num">' + stepNo + '</span><span class="ps-ht"><span class="ps-h">' + title + '</span>' + (sub ? '<span class="ps-hs">' + sub + '</span>' : '') + '</span></div>'; }
  var widthBox = wIn && wIn.closest('.product-form__input');
  if (widthBox) { var sh = document.createElement('div'); sh.innerHTML = head('Größe', 'Breite × Höhe in cm'); widthBox.parentNode.insertBefore(sh.firstChild, widthBox); }
  qChips.insertAdjacentHTML('afterbegin', head('Stückzahl', 'Auswählen oder eigene Menge eingeben'));
  var box = document.createElement('div');
  box.className = 'ps-cfg';
  var html = '';
  P.groups.forEach(function (g, gi) {
    html += '<fieldset class="ps-group" data-key="' + g.key + '"><legend>' + head(g.key, g.sub) + '</legend><div class="ps-opts">';
    g.options.forEach(function (o, oi) {
      var id = 'ps-' + gi + '-' + oi;
      var im = IMG[C.handle] && IMG[C.handle][gi] && IMG[C.handle][gi][oi];
      html += '<label class="ps-opt" for="' + id + '"><input type="radio" id="' + id + '" name="ps-' + gi + '" value="' + o.v + '"' + (oi === 0 ? ' checked' : '') + (o.addon ? ' data-addon="' + o.addon + '"' : '') + '>' +
        (im ? '<img class="ps-opt__img" src="' + swatch(im) + '" alt="' + o.v + '" loading="lazy" width="120" height="120">' : '') +
        '<span class="ps-opt__t">' + o.v + ' <em class="ps-add" hidden></em></span><span class="ps-opt__d">' + o.d + '</span></label>';
    });
    html += '</div></fieldset>';
  });
  if (P.colors) {
    html += '<fieldset class="ps-group"><legend>' + head('Garnfarben', 'Bis zu ' + P.colors.slots + ' wählen · <b class="ps-ycount">0</b> ausgewählt') + '</legend><div class="ps-sw ps-yarn">' +
      P.colors.yarn.map(function (c, k) { return '<label class="ps-sw__i" title="' + c + '"><input type="checkbox" value="' + c + '"><img src="' + dropImg(YARN_IMG[k]) + '" alt="' + c + '" loading="lazy" width="48" height="48"><span>' + c + '</span></label>'; }).join('') + '</div></fieldset>';
    html += '<fieldset class="ps-group"><legend>' + head('Hintergrund', 'Filzfarbe') + '</legend><div class="ps-sw ps-felt">' +
      P.colors.felt.map(function (c, k) { return '<label class="ps-sw__i" title="' + c + '"><input type="radio" name="ps-felt" value="' + c + '"><img src="' + dropImg(FELT_IMG[k]) + '" alt="' + c + '" loading="lazy" width="48" height="48"><span>' + c + '</span></label>'; }).join('') + '</div></fieldset>';
  }
  html += '<fieldset class="ps-group"><legend>' + head('Ihr Motiv', 'JPG, PNG oder PDF · optional, Sie können es auch später per E-Mail senden') + '</legend>' +
    '<input type="file" class="ps-file" accept=".jpg,.jpeg,.png,.pdf"></fieldset>' +
    '<fieldset class="ps-group"><legend>' + head('Anmerkungen', 'Optional') + '</legend><textarea class="ps-notes" rows="3" placeholder="Farben, Text, besondere Wünsche …"></textarea></fieldset>' +
    '<div class="ps-sum" aria-live="polite"></div><div class="ps-nudge" hidden></div><div class="ps-err" role="alert" hidden></div>';
  box.innerHTML = html;
  buttons.insertBefore(box, buttons.firstChild);

  var yarnOrder = [];
  box.addEventListener('change', function (e) {
    var cb = e.target;
    if (!cb.closest || !cb.closest('.ps-yarn')) return;
    if (cb.checked) { if (yarnOrder.length >= P.colors.slots) { cb.checked = false; return; } yarnOrder.push(cb.value); }
    else yarnOrder = yarnOrder.filter(function (v) { return v !== cb.value; });
    var n = box.querySelector('.ps-ycount'); if (n) n.textContent = yarnOrder.length;
  });
  var sumEl = box.querySelector('.ps-sum'), nudgeEl = box.querySelector('.ps-nudge'), errEl = box.querySelector('.ps-err');
  var finalWrap = document.querySelectorAll('.finalprice'), finalRes = document.querySelectorAll('.finalprice-result');
  var surfaceRes = document.querySelectorAll('.surface-result');

  function priceTextNodes() {
    var out = [];
    document.querySelectorAll('.price__regular .price-item--regular, .price__regular .price-item').forEach(function (item) {
      if (item.closest('.ps-cfg')) return;
      out.push(item); // ganzer Text, sonst bleibt ein vom Währungsformat erzeugter <span> als zweiter Preis stehen
    });
    return out;
  }
  var priceNodes = priceTextNodes();
  var anchorNote = null;
  var priceBox = document.querySelector('.price__regular');
  var priceHost = priceBox && priceBox.closest('.price');
  if (priceHost) { anchorNote = document.createElement('div'); anchorNote.className = 'ps-anchor'; priceHost.parentNode.insertBefore(anchorNote, priceHost.nextSibling); }
  // "bei 2.000 Stück" direkt hinter dem Preis (nach "(je Stk.)")
  var atQty = null;
  if (priceBox) { atQty = document.createElement('span'); atQty.className = 'ps-atqty'; priceBox.appendChild(atQty); }

  /* ---------- Rechnen ---------- */
  function tierIndex(area) {
    for (var i = 0; i < tiers.length; i++) {
      var last = i === tiers.length - 1;
      if (area >= tiers[i].lo && (area < tiers[i].hi || (last && area <= tiers[i].hi + 1e-9))) return i;
    }
    return -1;
  }
  function read() {
    var w = num(wIn && wIn.value) || 0, h = num(hIn && hIn.value) || 0, q = parseInt(qIn && qIn.value, 10) || 0;
    var area = Math.round(w * h * 100) / 100;
    var ti = tierIndex(area);
    var st = { w: w, h: h, q: q, area: area, ti: ti, addons: [], err: '' };
    if (!(w > 0 && h > 0)) st.err = 'Bitte Breite und Höhe eingeben.';
    else if (area > MAX_AREA + 1e-9) st.err = 'Maximale Fläche: ' + de(MAX_AREA) + ' cm². Für größere Patches schreiben Sie uns bitte.';
    else if (ti < 0) st.err = 'Diese Größe ist nicht verfügbar.';
    else if (!q) st.err = 'Bitte eine Stückzahl wählen.';
    else if (q < MIN_QTY) st.err = 'Mindestbestellmenge: ' + MIN_QTY + ' Stück.';
    if (st.err) return st;
    var tier = tiers[ti], qi = 0;
    for (var k = 0; k < tier.variants.length; k++) if (q >= tier.variants[k].min) qi = k;
    st.tierVariant = tier.variants[qi];
    st.qi = qi;
    var unit = st.tierVariant.price;
    box.querySelectorAll('input[type=radio]:checked[data-addon]').forEach(function (r) {
      var av = addonVariant(r.dataset.addon, ti);
      if (av) { st.addons.push(av); unit += av.price; }
      else st.err = 'Die Option „' + r.value + '“ ist für diese Größe nicht verfügbar.';
    });
    st.unit = Math.round(unit * 100) / 100;
    st.total = Math.round(st.unit * q * 100) / 100;
    // Nächste Mengenstufe insgesamt günstiger?
    var nv = tier.variants[qi + 1];
    if (nv) {
      var nUnit = st.unit - st.tierVariant.price + nv.price, nTotal = nUnit * nv.min;
      if (nTotal <= st.total) st.nudge = { q: nv.min, total: nTotal };
    }
    return st;
  }

  function unitFor(ti, q, withAddons) {
    if (ti < 0) return null;
    var t = tiers[ti], v = t.variants[0];
    t.variants.forEach(function (x) { if (q >= x.min) v = x; });
    var u = v.price;
    if (withAddons) box.querySelectorAll('input[type=radio]:checked[data-addon]').forEach(function (r) { var av = addonVariant(r.dataset.addon, ti); if (av) u += av.price; });
    return Math.round(u * 100) / 100;
  }
  var anchorUnit = unitFor(tierIndex(Math.round(AW * AH * 100) / 100), ANCHOR_Q, false);
  // "ab"-Preis: günstigster Stückpreis (höchste Mengenstufe, kleinste Größe)
  var TOP_Q = qtyMins[qtyMins.length - 1];
  var lowUnit = tiers.reduce(function (lo, t, i) { var u = unitFor(i, TOP_Q, false); return lo == null || u < lo ? u : lo; }, null);

  function render() {
    var st = read();
    var sizeOk = st.w > 0 && st.h > 0 && st.ti >= 0 && st.area <= MAX_AREA + 1e-9;
    qChips.querySelectorAll('.ps-qty__b').forEach(function (b) {
      var m = +b.dataset.q, u = sizeOk ? unitFor(st.ti, m, true) : null;
      b.querySelector('.ps-qty__p').textContent = u != null ? fmt.format(u) + '/Stk.' : ' ';
      b.classList.toggle('is-on', st.q === m);
    });
    surfaceRes.forEach(function (el) { el.textContent = de(st.area); });
    // Aufpreise an den Optionen
    box.querySelectorAll('input[data-addon]').forEach(function (r) {
      var em = r.parentNode.querySelector('.ps-add');
      var av = st.ti >= 0 ? addonVariant(r.dataset.addon, st.ti) : null;
      if (av) { em.textContent = '(+ ' + fmt.format(av.price) + ')'; em.hidden = false; } else em.hidden = true;
    });
    var ok = !st.err;
    priceNodes.forEach(function (n) { n.textContent = (ok ? fmt.format(st.unit) : (sizeOk ? 'ab ' + fmt.format(unitFor(st.ti, TOP_Q, true)) : 'ab ' + fmt.format(lowUnit))) + ' '; });
    finalRes.forEach(function (el) { el.textContent = ok ? fmt.format(st.total) : '—'; });
    finalWrap.forEach(function (el) { el.style.display = ok ? '' : 'none'; });
    sumEl.classList.toggle('is-ok', ok);
    if (ok) sumEl.innerHTML = '<div class="ps-sum__t">Ihr Preis</div>' +
      '<div class="ps-sum__row"><span>' + de(st.w) + ' × ' + de(st.h) + ' cm · ' + de(st.area) + ' cm²</span><span>' + st.q + ' Stk. × ' + fmt.format(st.unit) + '</span></div>' +
      '<div class="ps-sum__tot"><span>Gesamt inkl. MwSt.</span><b>' + fmt.format(st.total) + '</b></div>' +
      '<div class="ps-sum__f">Kostenloses Freigabemuster · produziert wird erst nach Ihrer Freigabe</div>';
    else if (!(st.w > 0 && st.h > 0)) sumEl.textContent = 'Geben Sie Ihre Größe ein – der Preis erscheint sofort.';
    else if (sizeOk && !st.q) sumEl.textContent = 'Jetzt die Stückzahl wählen.';
    else sumEl.textContent = '';
    if (atQty) atQty.textContent = (!ok && (sizeOk || !(st.w > 0 && st.h > 0))) ? ' bei ' + TOP_Q.toLocaleString('de-DE') + ' Stück' : '';
    if (anchorNote) anchorNote.textContent = (!ok && !(st.w > 0 && st.h > 0)) ? 'Beispiel: ' + de(AW) + ' × ' + de(AH) + ' cm bei ' + ANCHOR_Q + ' Stück = ' + fmt.format(anchorUnit) + '/Stk.' : '';
    if (ok && st.nudge) {
      nudgeEl.hidden = false;
      nudgeEl.innerHTML = 'Tipp: <a href="#" data-q="' + st.nudge.q + '">' + st.nudge.q + ' Stück</a> kosten insgesamt nur ' + fmt.format(st.nudge.total) + '.';
    } else nudgeEl.hidden = true;
    errEl.hidden = ok || !touched; errEl.textContent = st.err;
    if (submitBtn) submitBtn.disabled = !ok;
    return st;
  }

  var touched = false;
  [wIn, hIn, qIn].forEach(function (el) { if (el) el.addEventListener('input', function () { touched = true; render(); }); if (el) el.addEventListener('change', render); });
  box.addEventListener('change', render);
  nudgeEl.addEventListener('click', function (e) { var a = e.target.closest('a[data-q]'); if (!a) return; e.preventDefault(); qIn.value = a.dataset.q; render(); });
  // +/- Buttons von Dawn
  document.addEventListener('click', function (e) { if (e.target.closest('.quantity__button')) setTimeout(function () { if (qIn && +qIn.value < MIN_QTY) qIn.value = MIN_QTY; touched = true; render(); }, 0); });
  // Größen-Chips ("Welche Größe passt?")
  document.addEventListener('click', function (e) { if (e.target.closest('.ps-sz')) setTimeout(render, 30); });

  /* ---------- In den Warenkorb ---------- */
  function setBusy(b) { if (!submitBtn) return; submitBtn.classList.toggle('loading', b); submitBtn.setAttribute('aria-disabled', b); var sp = submitBtn.querySelector('.loading-overlay__spinner, .loading__spinner'); if (sp) sp.classList.toggle('hidden', !b); }
  function showErr(m) { errEl.textContent = m; errEl.hidden = false; }

  form.addEventListener('submit', function (e) {
    e.preventDefault(); e.stopImmediatePropagation();
    touched = true;
    var st = render();
    if (st.err) { showErr(st.err); return; }
    var file = box.querySelector('.ps-file').files[0];
    if (file && file.size > 20 * 1024 * 1024) { showErr('Die Datei ist zu groß (max. 20 MB).'); return; }
    var group = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    // Eine Warenkorbzeile pro Bestellung: die Preis-Variante (Größe + Mengenstaffel) trägt alle Angaben.
    // Add-ons (Klett usw.) kommen als eigene Zeilen mit derselben Gruppe dazu.
    var items = [];
    st.addons.forEach(function (a) { items.push({ id: a.id, quantity: st.q, properties: { _ps_group: group, _ps_role: 'addon' } }); });
    setBusy(true); errEl.hidden = true;
    (items.length ? fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw Object.assign(new Error(j.description || j.message || 'Konnte nicht in den Warenkorb gelegt werden.'), { rollback: group }); }); }) : Promise.resolve())
      .then(function () {
        var fd = new FormData();
        fd.append('id', st.tierVariant.id);
        fd.append('quantity', st.q);
        fd.append('properties[Breite (cm)]', de(st.w));
        fd.append('properties[Höhe (cm)]', de(st.h));
        fd.append('properties[Fläche]', de(st.area) + ' cm²');
        box.querySelectorAll('.ps-opts input[type=radio]:checked').forEach(function (r) { fd.append('properties[' + r.closest('.ps-group').dataset.key + ']', r.value); });
        yarnOrder.forEach(function (c, k) { fd.append('properties[Farbe ' + (k + 1) + ']', c); });
        var felt = box.querySelector('.ps-felt input:checked'); if (felt) fd.append('properties[Hintergrundfarbe]', felt.value);
        var notes = box.querySelector('.ps-notes').value.trim(); if (notes) fd.append('properties[Anmerkungen]', notes);
        if (file) fd.append('properties[Motiv]', file);
        fd.append('properties[_ps_group]', group);
        fd.append('properties[_ps_role]', 'main');
        fd.append('properties[_ps_set]', C.set);
        fd.append('properties[_ps_product]', C.handle);
        fd.append('properties[_ps_tier]', st.ti);
        fd.append('properties[_ps_addons]', box.querySelectorAll('input[type=radio]:checked[data-addon]').length ? Array.prototype.map.call(box.querySelectorAll('input[type=radio]:checked[data-addon]'), function (r) { return r.dataset.addon; }).join(',') : '');
        var cn = document.querySelector('cart-notification, cart-drawer');
        if (cn && cn.getSectionsToRender) { fd.append('sections', cn.getSectionsToRender().map(function (s) { return s.id; })); fd.append('sections_url', window.location.pathname); }
        return fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) { throw Object.assign(new Error(j.description || j.message || 'Konnte nicht in den Warenkorb gelegt werden.'), { rollback: group }); } return j; }); });
      })
      .then(function (j) {
        var cn = document.querySelector('cart-notification, cart-drawer');
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ps-configurator' });
        if (cn && cn.renderContents && j.sections) cn.renderContents(j); else window.location = '/cart';
      })
      .catch(function (err) {
        showErr(err.message || 'Konnte nicht in den Warenkorb gelegt werden.');
        // Add-on-Zeilen wieder entfernen, falls die Hauptzeile nicht hinzugefügt wurde
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          var upd = {}; cart.items.forEach(function (it) { if (it.properties && it.properties._ps_group === group) upd[it.key] = 0; });
          if (Object.keys(upd).length) return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: upd }) });
        });
      })
      .finally(function () { setBusy(false); });
  }, true);

  // Dawn setzt die Menge nach einem Cart-Update zurück -> wiederherstellen
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(function () { if (qIn && qIn.value && +qIn.value < MIN_QTY) qIn.value = MIN_QTY; render(); }, 50); });
    render();
  });

  render();
})();
